import translate from '@translate';
import { useLocation, useNavigate } from 'react-router-dom';
import { TabType } from 'src/components/BodyTopBlock';
import { useCheckPermission } from 'src/utils/checkPermission';

/** Shared tabs under Přeprava: transports + package types + Geis packing types. */
export const getTransportsSectionTopBlockParams = (): {
    tabs: TabType[];
    selected: string;
    handleChange: (newUrl: string) => void;
} => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleChange = (newUrl: string) => {
        if (newUrl === 'package-types') {
            navigate('/transports/package-types/');
            return;
        }
        if (newUrl === 'geis-packing-types') {
            navigate('/transports/geis-packing-types/');
            return;
        }
        if (newUrl === 'pallet-types') {
            navigate('/transports/pallet-types/');
            return;
        }
        navigate('/transports/');
    };

    const pathParts = location.pathname.split('/');
    const selected =
        pathParts[2] === 'package-types'
            ? 'package-types'
            : pathParts[2] === 'geis-packing-types'
              ? 'geis-packing-types'
              : pathParts[2] === 'pallet-types'
                ? 'pallet-types'
                : 'transports';

    const permissionTransports = useCheckPermission('TRANSPORT.LIST');
    const permissionPackageTypes = useCheckPermission('TRANSPORT_PACKAGE_TYPE.LIST');

    const tabs: TabType[] = [
        {
            value: 'transports',
            label: translate('transports.tab.transports'),
            hidden: !permissionTransports,
        },
        {
            value: 'package-types',
            label: translate('transports.tab.packageTypes'),
            hidden: !permissionPackageTypes,
        },
        {
            value: 'pallet-types',
            label: translate('transports.tab.palletTypes'),
            hidden: !permissionPackageTypes,
        },
        {
            value: 'geis-packing-types',
            label: translate('transports.tab.geisPackingTypes'),
            hidden: !permissionPackageTypes,
        },
    ];

    return {
        tabs,
        selected,
        handleChange,
    };
};
